import { Link, useLocation } from 'react-router-dom';
import h from '../../../../helpers/common';
import { useSelector } from 'react-redux';
import { IStore } from '../../../../interfaces/StoreTypes';
import { ROUTE_CONSTANT } from '../../../../config/constants';
import { __ } from '../../../../translations';
import useLanguage from '../../../../hooks/useLanguage';
import { handleSwitchLanguage } from '../../utils/headerUtils';
import { useRedirection } from '../../../../hooks/useRedirection';

interface LanguageToggleProps {
    /** Optional prop to specify a route to navigate to after switching language */
    navigateTo?: string;
}

export const LanguageToggle: React.FC<LanguageToggleProps> = ({ navigateTo }) => {
    const location = useLocation();
    const { selectedProfile } = useSelector((state: IStore) => state.profile);
    const redirectTo = useRedirection();
    const language = useLanguage();
    return (
        <Link
            to={h.getAltLanguageURL(language === 'en' ? 'ar' : 'en', location)}
            onClick={(e) => {
                handleSwitchLanguage(e, language);
                redirectTo(navigateTo || (selectedProfile.kidsMode ? ROUTE_CONSTANT.KIDS_HOME : ''));
            }}
            style={{ color: '#fff' }}
        >
            {language === 'en' ? __('settings_lang_Arabic') : __('settings_lang_English')}
        </Link>
    );
};
